// extracted by mini-css-extract-plugin
module.exports = {"resourceTiles":"style__resourceTiles__EGrzt"};